import React from 'react';
import { Modal } from 'antd';

const ChangePageModal = ({ visible, handleOk, handleCancel }) => {
  return (
    <div className='change-page-modal'>
      <Modal
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        okButtonProps={{
          children: 'OK'
        }}
        cancelButtonProps={{
          children: 'Cancel'
        }}
      >
        <p>Are you sure that you want to change your domain?</p>
      </Modal>
    </div>
  );
};

export default ChangePageModal;
